export default __webpack_public_path__ + "static/media/2-gray.cb787a57.png";